<script>
import appConfig from "@/app.config";
import { notificationMethods } from "@/state/helpers";
import {apiClient} from "@/state/modules/apiClient";
import Vue from "vue";
import moment from "moment";

export default {
  name: "app",
  page: {
   // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  mounted() {
    // document.querySelector("html").setAttribute('dir', 'rtl')
  },
 async created() {
  //  Check Auth when run app
    const token = localStorage.getItem('user-token')
    const auth = localStorage.getItem('auth-user')
    let authParse = JSON.parse(auth)
    // if(authParse){
    //   const d = moment(authParse.expiryDate);
    //   let dn = moment();
    //   if(authParse.token && d > dn){
    //     Vue.prototype.$auth_token = authParse.token;
    //   }else{
    //     localStorage.removeItem("congdan-token");
    //     localStorage.removeItem("auth-congdan");
    //     // this.$router.push("/dang-nhap");
    //     window.location.href="/"
    //   }
    // }
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
  },
};
</script>

<template>
  <div id="app">
    <notifications group="foo" />
    <RouterView />
  </div>
</template>
<style>
  html, body {
    max-width: 100%;
    overflow-x: hidden;
  }

</style>
